import { makeAutoObservable } from "mobx";
import { IllustrationIdApi, isGettedIllustrationIdDTO } from "./IllustrationId";

export interface IllustrationApi extends IllustrationIdApi {
  illustrationName: string;
  illustrationType: string;
  illustration: File | string;
  illustrationAuthor?: string;
}

export class EmptyIllustrationImpl implements IllustrationApi {
  illustrationName: string = "";
  illustrationType: string = "";
  illustrationId: string = "";
  illustration: string | File = "";
  illustrationAuthor?: string;
}

export class ObservableIllustrationImpl implements IllustrationApi {
  illustrationName: string;
  illustrationType: string;
  illustrationId: string;
  illustration: string | File;
  illustrationAuthor?: string;

  constructor(illustration: IllustrationApi) {
    this.illustrationName = illustration.illustrationName;
    this.illustrationType = illustration.illustrationType;
    this.illustrationId = illustration.illustrationId;
    this.illustrationAuthor = illustration.illustrationAuthor;
    this.illustration = illustration.illustration;

    makeAutoObservable(this);
  }
}

export let isGettedIllustrationDTO = (
  variable: unknown
): variable is IllustrationApi => {
  return (
    isGettedIllustrationIdDTO(variable) &&
    "illustrationName" in variable &&
    typeof variable.illustrationName === "string" &&
    "illustrationType" in variable &&
    typeof variable.illustrationType === "string" &&
    "illustration" in variable &&
    typeof variable.illustration === "string" &&
    (!("illustrationAuthor" in variable) ||
      typeof variable.illustrationAuthor === "string")
  );
};
